import { BooleanField } from 'react-admin';

import { GetInstrumentOneResponse } from '@Common/types/bo/instruments';

import { ShowFields, ShowSection } from '@sh4res/bo-common/components';
import { CountriesStatusList } from '@sh4res/bo-common/components/Instruments/countries_status/CountriesStatusList';

export const CryptoSection = () => (
  <ShowSection label="resources.bo_common.instruments.sections.statuses">
    <ShowFields<GetInstrumentOneResponse & { country_settings: string }>
      fields={{
        tradable: <BooleanField data-testid="BoExternalCryptoSection_TradableField" />,
        fractionable: <BooleanField data-testid="BoExternalCryptoSection_FractionableField" />,
        is_price_fetched: (
          <BooleanField data-testid="BoExternalCryptoSection_IsPriceFetchedField" />
        ),
        is_enabled: <BooleanField data-testid="BoExternalCryptoSection_IsEnabledField" />,
        is_halted: <BooleanField data-testid="BoExternalCryptoSection_IsHaltedField" />,
        country_settings: <CountriesStatusList mode="list" />,
      }}
    />
  </ShowSection>
);
